import React from "react";
import { Translation } from "./transComp";

export function getTransl(val) {
  if (
    val === "TasklistStart Date" ||
    val === "TasklistDue Date" ||
    val === "TasklistLevel" ||
    val === "TasklistOrder" ||
    val === "TasklistLevelNumber" ||
    val === "TasklistName" ||
    val === "TasklistStatus" ||
    val === "TasklistColor" ||
    val === "TasklistDescription" ||
    val === "TasklistResponsible" ||
    val === "TasklistResource" ||
    val === "TasklistCost" ||
    val === "TasklistDuration" ||
    val === "TasklistDependency" ||
    val === "TasklistSharedFiles" ||
    val === "TasklistUndefined" ||
    val === "TasklistNot started" ||
    val === "TasklistStarted" ||
    val === "TasklistIn progress" ||
    val === "TasklistFinished" ||
    val === "TasklistStandby" ||
    val === "TasklistCancelled" ||
    val === "TasklistResource Management" ||
    val === "TasklistPercentComplete" ||
    val === "TasklistWorkload" ||
    val === "HomeWorksheet" ||
    val === "HomeProject" ||
    val === "TasklistChecklist" ||
    val === "TasklistResponsible Management" ||
    val === "CRMcompanyName" ||
    val === "CRMadditional" ||
    val === "CRMleadStatus" ||
    val === "CRMcreated" ||
    val === "CRMmodified" ||
    val === "CRMcomments" ||
    val === "CRMcompanySiret" ||
    val === "CRMcompanyAddress" ||
    val === "CRMclientNumber" ||
    val === "CRMleadOwner" ||
    val === "CRMleadSource" ||
    val === "CRMindustry" ||
    val === "CRMcontact" ||
    val === "CRMwebsite" ||
    val === "CRMnumberOfEmployees" ||
    val === "CRMnetProfit" ||
    val === "CRMannualRevenue" ||
    val === "ProjectViewFirstName" ||
    val === "ProjectViewLastName" ||
    val === "ContactNumber" ||
    val === "TasklistDescription"
    // val === "RiskmanagementHigh"
  ) {
    return <Translation str={val} />;
  } else {
    return val;
  }
}

const ObjEN = {
  TasklistUndefined: "Undefined",
  "TasklistNot started": "To do",
  TasklistStarted: "Started",
  "TasklistIn progress": "In progress",
  TasklistFinished: "Finished",
  TasklistStandby: "Standby",
  TasklistCancelled: "Cancelled",
  TasklistLastDay: "Last Day",
  TasklistTooLate: "Too Late",
  TasklistInTime: "In Time",
  ItemViewSelectDocument: "Select a document type",
  ItemTaskListTrans: "To-do list",
  ItemGanttChartTrans: "Gantt Chart",
  ItemFollowUpTrans: "Backlog",
  ItemResourceTrans: "Resource management",
  ItemWBSTrans: "Work breakdown structure (WBS)",
  ItemDashboard: "Dashboard",
  ItemSave: "Save",
  ItemSettings: "Settings",
  HeaderSolutions: "Solutions",
  HeaderLanding: "Clients",
  HeaderOffer: "Offer",
  "TasklistStart Date": "Start Date",
  "TasklistDue Date": "Due Date",
  TasklistLevel: "Level",
  TasklistOrder: "List number",
  TasklistLevelNumber: "Structure",
  TasklistName: "Task name",
  TasklistStatus: "Status",
  TasklistColor: "Color",
  TasklistDescription: "Description",
  TasklistResponsible: "Responsible",
  TasklistResource: "Resource",
  TasklistCost: "Cost [€]",
  TasklistDuration: "Duration",
  TasklistDependency: "Successor",
  TasklistSharedFiles: "Shared files",
  "TasklistResource Management": "Resource management",
  TasklistPercentComplete: "Completion [%]",
  "TasklistResponsible Management": "Responsible management",
  NotificationStatus:
    "#TASK_NAME task changed from #FROM_STATUS to #TO_STATUS.",
  NotificationTime: "#TASK_NAME task #START_FINISH #DELAY.",
  TasklistTypeFilter: "Taper pour filtrer...",
  TasklistEstimatedDuration: "Estimated duration",
  TasklistRealizedDuration: "Effective duration",
  ProfileInTime: "On time",
  ProfileLastDay: "Last day",
  ProfileTooLate: "Too late",
  ManagerRessources: "Resources",
  ItemProject: "Project",
  ItemWorksheet: "Worksheet",
  ManagerEstimatedTime: "Estimated time",
  ManagerRealTime: "Actual time",
  ManagerEstimatedCost: "Estimated cost",
  ManagerRealisedCost: "Actual cost",
  ProjectViewFirstName: "First name",
  ProjectViewLastName: "Last name",
};
const ObjFR = {
  TasklistUndefined: "Indéfinie",
  "TasklistNot started": "A faire",
  TasklistStarted: "Commencé",
  "TasklistIn progress": "En cours",
  TasklistFinished: "Fini",
  TasklistStandby: "En attente",
  TasklistCancelled: "Annulé",
  TasklistLastDay: "Dernier jour",
  TasklistTooLate: "En retard",
  TasklistInTime: "Dans les temps",
  ItemTaskListTrans: "Liste de tâches",
  ItemGanttChartTrans: "Diagramme de Gantt",
  ItemFollowUpTrans: "Suivi",
  ItemResourceTrans: "Gestion des ressources",
  ItemWBSTrans: "Structure de découpage du projet (SDP)",
  ItemDashboard: "Tableau de board",
  ItemSave: "Sauvegarder",
  ItemSettings: "Configuration",
  HeaderSolutions: "Solutions",
  HeaderLanding: "Clients",
  HeaderOffer: "Offre",
  "TasklistStart Date": "Date de début",
  "TasklistDue Date": "Fin",
  TasklistLevel: "Niveau",
  TasklistOrder: "Numéro de liste",
  TasklistLevelNumber: "Structure",
  TasklistName: "Nom de la tâche",
  TasklistStatus: "Statut",
  TasklistColor: "Couleur",
  TasklistDescription: "Description",
  TasklistResponsible: "Responsable",
  TasklistResource: "Ressource",
  TasklistCost: "Coût [€]",
  TasklistDuration: "Durée",
  TasklistDependency: "Successeur",
  TasklistSharedFiles: "Fichiers partagés",
  "TasklistResource Management": "Gestion des ressources",
  TasklistPercentComplete: "Achèvement [%]",
  "TasklistResponsible Management": "Gestion des responsables",
  NotificationStatus:
    "La tâche #NOM_DE_LA_TACHE est passé de #DE_STATUS à #A_STATUS.",
  NotificationTime: "La tâche #NOM_DE_LA_TACHE #DEBUT_FIN #DELAI.",
  TasklistTypeFilter: "Taper pour filtrer...",
  TasklistEstimatedDuration: "Durée estimée",
  TasklistRealizedDuration: "Durée effective",
  ProfileInTime: "Dans les temps",
  ProfileLastDay: "Echéance aujourd’hui",
  ProfileTooLate: "En retard",
  ManagerRessources: "Ressources",
  ItemProject: "Projet",
  ItemWorksheet: "Feuille de travail",
  ManagerEstimatedTime: "Temps estimé",
  ManagerRealTime: "Temps réalisé",
  ManagerEstimatedCost: "Coût estimé",
  ManagerRealisedCost: "Coût réalisé",
  ProjectViewFirstName: "Prénom",
  ProjectViewLastName: "Nom de famille",
};
const ObjDE = {
  TasklistUndefined: "Nicht definiert",
  "TasklistNot started": "Zu machen",
  TasklistStarted: "Angefangen",
  "TasklistIn progress": "In Bearbeitung",
  TasklistFinished: "Beendet",
  TasklistStandby: "Standby",
  TasklistCancelled: "Abgebrochen",
  TasklistLastDay: "Letzter Tag",
  TasklistTooLate: "Verspätet",
  TasklistInTime: "Rechtzeitig",
  ItemTaskListTrans: "Aufgabenliste",
  ItemGanttChartTrans: "Gantt-Diagramm",
  ItemFollowUpTrans: "Aufgabenverfolgung",
  ItemResourceTrans: "Ressourceneinteilung",
  ItemWBSTrans: "Projektstrukturplan",
  ItemDashboard: "Übersicht",
  ItemSave: "Speichern",
  ItemSettings: "Einstellungen",
  HeaderSolutions: "Lösungen",
  HeaderLanding: "Kunden",
  "TasklistStart Date": "Beginn",
  "TasklistDue Date": "Ende",
  HeaderOffer: "Angebot",
  TasklistLevel: "Ebene",
  TasklistOrder: "Listennummer",
  TasklistLevelNumber: "Struktur",
  TasklistName: "Name der Aufgabe",
  TasklistStatus: "Status",
  TasklistColor: "Farbe",
  TasklistDescription: "Beschreibung",
  TasklistResponsible: "Verantworlicher",
  TasklistResource: "Ressource",
  TasklistCost: "Kosten [€]",
  TasklistDuration: "Dauer",
  TasklistDependency: "Nachfolger",
  TasklistSharedFiles: "Gemeinsame Dateien",
  "TasklistResource Management": "Ressourceneinteilung",
  TasklistPercentComplete: "Fertigstellung [%]",
  "TasklistResponsible Management": "Einteilung der Verantwortlichen",
  NotificationStatus:
    "Die Aufgabe #AUFGABENNAME wurde von #VON_STATUS zu #ZU_STATUS geändert.",
  NotificationTime: "#Die Aufgabe #AUFGABENNAME #BEGINN_ENDE #ZEITLIMIT.",
  TasklistTypeFilter: "Um zu filtern bitte schreiben",
  TasklistEstimatedDuration: "Geschätzte Dauer",
  TasklistRealizedDuration: "Effektive Dauer",
  ProfileInTime: "Im Zeitplan",
  ProfileLastDay: "Heute fällig",
  ProfileTooLate: "Verspätet",
  ManagerRessources: "Ressourcen",
  ItemProject: "Projekt",
  ItemWorksheet: "Arbeitsblatt",
  ManagerEstimatedTime: "Geschätzte Zeit",
  ManagerRealTime: "Tatsächliche Zeit",
  ManagerEstimatedCost: "Geschätzte Kosten",
  ManagerRealisedCost: "Tatsächliche Kosten",
  ProjectViewFirstName: "Vorname",
  ProjectViewLastName: "Nachname",
};
export function getLegendTransl(lang, val) {
  let locLan = null;
  if (lang === "en") {
    locLan = ObjEN;
  } else if (lang === "fr") {
    locLan = ObjFR;
  } else if (lang === "de") {
    locLan = ObjDE;
  }
  if (locLan === null) {
    return val;
  } else {
    if (locLan[val]) {
      return locLan[val];
    } else {
      return val;
    }
  }
}
